<template>
  <div
    :class="showSticky ? 'sticky top-0 z-50' : 'relative'"
    class="flex justify-center"
  >
    <header
      class="header transition-all"
      :class="[{ 'is-open': isOpen }, setStickyStyling ? 'header-small' : 'lg:h-28']"
    >
      <div class="header-inner">
        <div class="header-menu-btn">
          <kf-button
            class="btn-nav"
            @click="toggleMenu"
          >
            <span
              aria-hidden="true"
              class="btn-nav__line btn-nav__line--first"
            /><span
              aria-hidden="true"
              class="btn-nav__line btn-nav__line--second"
            /><span
              aria-hidden="true"
              class="btn-nav__line btn-nav__line--third"
            /><span class="sr-only">Open menu</span>
          </kf-button>
        </div>
        <div class="header-logo">
          <div
            :class="setStickyStyling? 'lg:top-0' : 'lg:top-2'"
            class="header-logo-primary"
          >
            <a
              v-if="!headerDisableLogoLink"
              :href="`${headerLogoLink}`"
              aria-label="Back to the homepage"
            >
              <kf-logo
                :logo="headerLogo"
                :set-sticky-styling="setStickyStyling"
              />
            </a>
            <kf-logo
              v-if="headerDisableLogoLink"
              :logo="headerLogo"
              :set-sticky-styling="setStickyStyling"
            />
          </div>
          <div
            v-if="headerLogoSecondaryLogoUrl"
            class="header-logo-secondary"
          >
            <img
              :src="headerLogoSecondaryLogoUrl"
              alt=""
              class="header__secondary-logo"
            >
          </div>
        </div>
        <div
          class="header-top transition-opacity"
          :class="[{ 'has-secondary-logo': headerLogoSecondaryLogoUrl }, setStickyStyling ? 'opacity-0' : 'opacity-100']"
        >
          <kf-navigation-meta
            :nav-meta-items="headerNavMetaItems"
            :nav-meta-current-locale="headerLocale"
            :nav-meta-languages="headerLanguages"
          />
        </div>
        <div
          class="header-bottom"
          :class="{ 'has-secondary-logo': headerLogoSecondaryLogoUrl, }"
        >
          <kf-navigation-main
            :nav-main-items="headerNavMainItems"
            :class="[isOpen ? 'is-open' : 'is-closed']"
            :nav-main-search-action="headerNavMainSearchAction"
            :nav-main-search-placeholder="headerNavMainSearchPlaceholder"
            :nav-main-cta="headerNavMainCta"
            :nav-sub-state="subnavIsOpen"
            :set-sticky-styling="setStickyStyling"
            @clicked="onClickChild"
          >
            <kf-navigation-meta
              class="only-small"
              :nav-meta-items="headerNavMetaItems"
              :nav-meta-current-locale="headerLocale"
              :nav-meta-languages="headerLanguages"
            />
          </kf-navigation-main>
        </div>
        <kf-link
          v-if="headerNavMainCta"
          class="header-cta"
          type="button-secondary"
          :href="headerNavMainCta.href"
        >
          {{ headerNavMainCta.label }}
        </kf-link>
      </div>
      <kf-navigation-sub
        :nav-sub-items="navSubItems"
        :nav-sub-extra-items="headerNavSubExtraItems"
        :class="{ 'is-open': subnavIsOpen }"
      />
    </header>
  </div>
</template>

<script>
import KfButton from '@/components/base/button/Button.vue';
import KfLink from '@/components/base/link/Link.vue';
import KfLogo from '@/components/base/logo/Logo.vue';
import KfNavigationMain from '@/components/navigation/navigation-main/NavigationMain.vue';
import KfNavigationMeta from '@/components/navigation/navigation-meta/NavigationMeta.vue';
import KfNavigationSub from '@/components/navigation/navigation-sub/NavigationSub.vue';

export default {
  name: 'KfHeader',
  components: {
    KfLogo,
    KfNavigationMain,
    KfNavigationMeta,
    KfNavigationSub,
    KfButton,
    KfLink,
  },
  props: {
    headerLogo: {
      type: String,
      default: '',
    },
    headerDisableLogoLink: {
      type: Boolean,
      default: false,
    },
    headerLogoSecondaryLogoUrl: {
      type: String,
      default: '',
    },
    headerNavMainItems: {
      type: Array,
      default: null,
    },
    headerNavMainSearchAction: {
      type: String,
      default: '',
    },
    headerNavMainSearchPlaceholder: {
      type: String,
      default: '',
    },
    headerNavMetaItems: {
      type: Array,
      default: null,
    },
    headerLocale: {
      type: String,
      default: 'nl',
    },
    headerLogoLink: {
      type: String,
      default: '/',
    },
    headerLanguages: {
      type: Array,
      default: null,
    },
    headerNavMainCta: {
      type: Object,
      default: null,
    },
    headerNavSubExtraItems: {
      type: Array,
      default: null,
    },
    showSticky: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isOpen: false,
      subnavIsOpen: false,
      setStickyStyling: false,
      selectedItem: {},
    };
  },
  computed: {
    navSubItems() {
      return this.selectedItem?.navigationSub || [];
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll () {
      if (window.scrollY > 209 && this.showSticky) {
         this.setStickyStyling = true
      } else if (window.scrollY < 140){
        this.setStickyStyling = false
      }
    },
    changeLanguage(headerLocale) {
      this.$formulate.setLocale(headerLocale);
    },
    toggleMenu: function() {
      this.isOpen = !this.isOpen;
    },
    onClickChild (selectedItem) {
      if (this.selectedItem === selectedItem) {
      // If the selected item is already open, close it
      this.subnavIsOpen = false;
      this.selectedItem = {};
    } else {
      // If a new item is clicked, update the selected item and open the submenu
      this.selectedItem = selectedItem;
      this.subnavIsOpen = true;
    }
    },
  },
};
</script>

<style lang="postcss" scoped>
.is-button-primary.pointer-events-auto {
  @apply py-2
}
.header {
  @apply w-full flex bg-white z-30 shadow;
  min-height: 60px;


  @screen lg {
    &-small {

      height: 68px;
    }
    @apply px-0;
  }
  &-menu-btn {
    .btn-nav {
      @apply absolute block mr-4;
      left: 20px;
      top: 20px;
      height: 20px;
      width: 20px;

      @screen lg {
        top: 50px;
      }

      @screen xl {
        @apply hidden;
      }

      &__line {
        display: block;
        width: 18px;
        height: 2px;
        border-radius: 2px;
        background-color: theme('colors.primary.bravo');
        position: absolute;
        left: 0;
        transition: all 300ms;
      }

      &__line--first {
        top: 3px;
      }

      &__line--second {
        top: 9px;
      }

      &__line--third {
        top: 15px;
        width: 13px;
      }
    }
  }

  &-logo {
    @apply absolute flex items-center;
    top: 0;
    left: 60px;
    z-index: 11;

    @screen lg {
      @apply top-0 left-0;
    }

    &-primary {
      @apply relative;
      transform: translateY(10px);
    }

    &-secondary {
      @apply hidden h-2/4 z-20 ml-4;

      @screen sm {
        @apply flex flex-col flex-nowrap justify-center items-start flex-grow ml-0;
      }

      @screen lg {
        @apply flex-grow-0 mr-10;
        transform: translateY(10px);
      }

      img {
        max-width: 8rem;
        max-height: 100%;
      }
    }
  }

  &.is-open {
    @screen md {
      @apply bg-transparent;
    }

    .btn-primary {
    }

    .btn-nav {
      &__line--first {
        top: 50%;
        transform: rotate(-45deg);
      }

      &__line--second {
        left: 10px;
        opacity: 0;
      }

      &__line--third {
        top: 50%;
        transform: rotate(45deg);
        width: 18px;
      }
    }
  }

  &-inner {
    @apply relative w-full mx-auto flex flex-col justify-end lg:container px-5 md:px-4;

    &-right {
      @screen lg {
        @apply flex-col items-end justify-center w-auto relative;
      }
    }
  }

  &-top {
    @apply flex justify-end ml-36 mb-auto;
    height: 40px;

    .navigation-meta {
      @apply hidden;

      @screen lg {
        @apply flex;
      }
    }

    &.has-secondary-logo {
      @apply ml-80;
    }
  }

  &-bottom {
    @apply flex ml-36;

    &.has-secondary-logo {
      @apply ml-80;
    }
  }

  &-cta {
    @apply absolute py-2 px-4;
    z-index: 10;
    top: 8px;
    right: 10px;

    @screen md {
      @apply hidden;
    }
  }
}
</style>
